// extracted by mini-css-extract-plugin
module.exports = {"defaultIcon":"CBIcons_defaultIcon__1DfdS","headerIcon":"CBIcons_headerIcon__1x3Jr","tableSort":"CBIcons_tableSort__sDaZj","download":"CBIcons_download__dOuwI"};